import { BaseModal, FormActions, FormSectionTitle } from '@practium/ui';
import { CROP_PHASE_LABELS } from '../../constants/maintenance.constants';
import { exportCycleCalendarToPdf } from '../../utils/cycleCalendarExport';
import {
	formatCyclePhaseRange,
	mapCycleCalendarSummary,
	type CycleCalendarData,
} from '../../utils/dynamicParcellingCycle';
import { CycleMonthCard } from './CycleMonthCard';
import { CyclePhaseDot } from './CyclePhaseDot';
import styles from './CycleCalendarModal.module.css';

const MODAL_WIDTH = '72rem';
const MODAL_HEIGHT = '95dvh';

interface CycleCalendarModalProps {
	isOpen: boolean;
	onClose: () => void;
	calendar: CycleCalendarData;
}

export const CycleCalendarModal = ({ isOpen, onClose, calendar }: CycleCalendarModalProps) => {
	const { subtitle, footer } = mapCycleCalendarSummary(calendar);

	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			title="Calendário do ciclo"
			subtitle={subtitle}
			maxWidth={MODAL_WIDTH}
			maxHeight={MODAL_HEIGHT}
			actions={
				<>
					<span className={styles.footer}>{footer}</span>
					<FormActions
						mode="view"
						onClose={onClose}
						onEdit={() => exportCycleCalendarToPdf(calendar)}
						editText="Exportar"
					/>
				</>
			}
		>
			<div className={styles.content}>
				<section className={styles.section}>
					<FormSectionTitle size="xsmall">Fases do ciclo</FormSectionTitle>
					<ul className={styles.phases}>
						{calendar.phases.map((range) => (
							<li key={`${range.phase}-${range.start}`} className={styles.phase}>
								<CyclePhaseDot phase={range.phase} />
								<span className={styles.phaseName}>
									{CROP_PHASE_LABELS[range.phase] ?? range.phase}
								</span>
								<span className={styles.phaseRange}>{formatCyclePhaseRange(range)}</span>
							</li>
						))}
					</ul>
				</section>
				<section className={styles.section}>
					<FormSectionTitle size="xsmall">Parcelamento mês a mês</FormSectionTitle>
					<div className={styles.months}>
						{calendar.months.map((month) => (
							<CycleMonthCard key={month.key} month={month} />
						))}
					</div>
				</section>
			</div>
		</BaseModal>
	);
};
